import { SxProps } from "@mui/material";

import InfoChip from "./InfoChip";

const MAX_LENGTH = 36;

/**
 * Function to determine if data is `true-like`; will return true for all truthy values including `0` & `false`.
 * @param data
 * @returns
 */
export const isFound = (data: any) => {
  return !!data || data === 0 || data === false;
};

/**
 * Function to dynamically render either value (if < 36 characters) or icon w/ tooltip.
 * @param value
 * @returns
 */
export const useSmartContent = (
  value: any,
  CUSTOM_MAX_LENGTH?: number,
  sx?: SxProps
) => {
  if (!isFound(value)) return "--";

  // convert value to string
  const str = String(value);

  // if value > 36 characters, render tooltip with icon; else, display raw value
  return str.length > (CUSTOM_MAX_LENGTH ?? MAX_LENGTH) ? (
    <InfoChip size="small" info={str} sx={sx} />
  ) : (
    str
  );
};
